import styled from "styled-components";

const ContenedorFiltros = styled.div`
    background: #fff;
    display: flex;
    padding: 1rem;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.2); //1er valor sobra izq a der, 2do valor sombra arriba a abajo, 3er valor dureza de sombra
    border-radius: 0.625rem;
    margin-bottom: 2rem; /* 30px */
`;

const ContenedorSelect = styled.div`
    width: 30%;
`;

const ContenedorGrupoSelect = styled.div`
    background: #fff;
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    border-radius: 0.625rem;
    margin-bottom: 1rem;
`;

const ContenedorFecha = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap:wrap; 
    width: 45%;
    justify-content: left;
    align-items: center;
`;

const ContenedorFechas = styled.div`
    background: #fff;
    display: flex;
    flex-direction: row;
    flex-wrap:wrap; 
    width: 80%;
    justify-content: space-between;
    align-items: center;
`;

const ContenedorBotonBusqueda = styled.div`
    width: 15%;
    height: 100%;
    padding-top: 2rem;
    padding-bottom: 1rem;
    justify-content: space-between;
    display: flex;
    align-items: end;
    flex-wrap:wrap; 
`;

const BotonPDF = styled.a`
    padding: 0;
    border: none;
    background: none;
    display: inline-flex;

    svg{
        font-size: 2.5rem;
        color: red;
    }
`;

const Formulario = styled.form`
    background: #fff;
    width: 90%;
    padding: 1.5rem 1.5rem;
    height: auto;
    margin-bottom: 2rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 1rem;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.2);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    input {
        width: 100%;
        text-align: left;
        padding: 0.50rem 0.8rem;
        font-family: 'Work Sans', sans-serif;
        &::placeholder {
            color: rgba(0,0,0,.2);
        }
    }
`;

const ContenedorInputsObjeto = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%
`;

const ContenedorInputsObjetoUnidad = styled.div`
    width: 30%
`;


const Input = styled.input`
    font-size: 1rem; /* 40px */
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    margin-top: .5rem;
    margin-bottom: 1rem;
 
    @media(max-width: 60rem){ /* 950px */
        font-size: 2.2rem; /* 24px */
    }
`;

const TextArea = styled.textarea`
    font-size: 1rem; /* 40px */
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    margin-top: .5rem;
    margin-bottom: 1rem;
    display: block;
    width: 100%;
 
    @media(max-width: 60rem){ /* 950px */
        font-size: 2.2rem; /* 24px */
    }
`;

const InputFecha = styled.input`
    font-size: 1rem; /* 40px */
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.5rem;
    margin-top: .5rem;
    margin-bottom: 1rem;
    padding: .6rem;
`;

const Etiqueta = styled.label`
    font-size: 1rem; /* 40px */
    color: #0f265c;
    width: 100%;
`;
 
const InputGrande = styled(Input)`
    font-size: 4.37rem; /* 70px */
    font-weight: bold;
`;
 
const ContenedorBoton = styled.div`
    display: flex;
    justify-content: end;
    margin: 2.5rem 0;  /* 40px */
`;

export {ContenedorFiltros, ContenedorSelect, ContenedorGrupoSelect, Formulario, Input, InputGrande, TextArea, ContenedorBoton, Etiqueta, ContenedorFechas, ContenedorFecha, ContenedorBotonBusqueda, InputFecha, ContenedorInputsObjeto, ContenedorInputsObjetoUnidad, BotonPDF};
